import finance_api from '../../../api/finances/_finance'

export default {
    storeLigneOperation(data) {
        return new Promise((resolve, reject) => {
            finance_api.storeLigneOperation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    removeAllItemsFromCaisse(data) {
        return new Promise((resolve, reject) => {
            finance_api.removeAllItemsFromCaisse(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    removeItemFromCaisse(data) {
        return new Promise((resolve, reject) => {
            finance_api.removeItemFromCaisse(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateLigneOpOrdonnance(data) {
        return new Promise((resolve, reject) => {
            finance_api.updateLigneOpOrdonnance(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}